import React, { useState, useRef, useEffect } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

// API
import ItemService from "../../../../services/supplier_appCommonService";
import LoaderSmall from "../../../../Components/LoaderSmall";


const FileUploadComponentForHB = ({
  allowedTypes = [],
  multiple = true,
  label,
  extraLabel = "",
  required,
  name,
  id,
  value,
  disabled,
  onSuccessUpload = () => {},
}) => {
  const fileInputRef = useRef(null);

  const [selectedFiles, setSelectedFiles] = useState([]);
  const [fileLinks, setFileLinks] = useState([]);
  // eslint-disable-next-line
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [uploadStatus, setUploadStatus] = useState(false);
  const [uploadingIndex, setUploadingIndex] = useState(null);
  
  // ✅ Track total files separately
  const [totalFilesCount, setTotalFilesCount] = useState(0);
  const [uploadedCount, setUploadedCount] = useState(0);

  // ✅ Clear selected files when multiple=false and value changes
  useEffect(() => {
    if (!multiple && value) {
      setSelectedFiles([]);
      setFileLinks([]);
      setTotalFilesCount(0);
      setUploadedCount(0);
    }
  }, [value, multiple]);

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);

    const filteredFiles = files.filter((file) => {
      const fileExtension = "." + file.name.split(".").pop().toLowerCase();
      return (
        allowedTypes.includes(file.type) || 
        allowedTypes.includes(fileExtension)
      );
    });

    const newFileLinks = filteredFiles.map((file) => ({
      name: file.name,
      url: URL.createObjectURL(file),
    }));

    if (filteredFiles.length !== files.length) {
      alert("Some files were not accepted due to unsupported file types.");
    }

    // For single file mode, replace completely
    if (multiple) {
      setSelectedFiles((prevFiles) => [...prevFiles, ...filteredFiles]);
      setFileLinks((prevLinks) => [...prevLinks, ...newFileLinks]);
    } else {
      setSelectedFiles(filteredFiles);
      setFileLinks(newFileLinks);
    }
  };

  // ✅ FIXED: Don't allow delete during upload
  const handleRemoveFile = (index) => {
    // Prevent deletion while uploading
    if (uploadStatus) {
      alert("Cannot delete files while uploading. Please wait.");
      return;
    }

    setSelectedFiles((prevFiles) =>
      prevFiles.filter((_, fileIndex) => fileIndex !== index)
    );
    
    setFileLinks((prevLinks) =>
      prevLinks.filter((_, fileIndex) => fileIndex !== index)
    );
    
    // ✅ Also reset counters if files are deleted
    setTotalFilesCount(0);
    setUploadedCount(0);
  };

  // ✅ FIXED: Upload individual file one by one with proper continuation
  // eslint-disable-next-line
  const uploadSingleFile = async (fileIndex, filesArray) => {
    // Check if file exists at this index
    if (fileIndex >= filesArray.length) {
      setUploadingIndex(null);
      setUploadStatus(false);
      setTotalFilesCount(0);
      setUploadedCount(0);
      return;
    }

    setUploadingIndex(fileIndex);
    setUploadStatus(true);
    
    // ✅ Increment upload count
    const currentUploadCount = uploadedCount + 1;
    setUploadedCount(currentUploadCount);

    const file = filesArray[fileIndex];
    const formData = new FormData();
    formData.append("files", file);

    if (value) {
      formData.append("attachmentId", value);
    }

    try {
      const item = await ItemService.uploadFiles(formData);
      
      const payload = {
        fieldName: name,
        attachmentId: item.attachmentId,
        id: item.attachmentId,
      };
      
      onSuccessUpload && onSuccessUpload(payload);
      getUploadedFiles(item?.attachmentId);

      // ✅ FIXED: Remove uploaded file from the list
      setSelectedFiles((prevFiles) => {
        const updated = prevFiles.filter((_, idx) => idx !== fileIndex);
        
        // ✅ FIXED: Check updated array length, not the old one
        if (updated.length > 0) {
          // Continue with next file
          setTimeout(() => {
            uploadSingleFile(fileIndex, updated);
          }, 500);
        } else {
          // All files uploaded
          setUploadingIndex(null);
          setUploadStatus(false);
          setTotalFilesCount(0);
          setUploadedCount(0);
        }
        
        return updated;
      });
      
      setFileLinks((prevLinks) =>
        prevLinks.filter((_, idx) => idx !== fileIndex)
      );

    } catch (error) {
      console.error("Upload failed for file:", file.name, error);
      alert(`Failed to upload ${file.name}. Please try again.`);
      setUploadingIndex(null);
      setUploadStatus(false);
      setTotalFilesCount(0);
      setUploadedCount(0);
    }
  };

  const getUploadedFiles = async (attachmentId) => {
    if (attachmentId) {
      let obj = { attachmentId };
      try {
        const item = await ItemService.getUploadedFiles(obj);
        setUploadedFiles(item.data);
      } catch (error) {
        console.error("Error fetching uploaded files:", error);
      }
    }
  };

  // ✅ FIXED: Properly initialize counters and pass files array
  // const handleUpload = () => {
  //   if (selectedFiles.length === 0) {
  //     alert("No files selected for upload.");
  //     return;
  //   }
    
  //   // ✅ Save total files count at the start
  //   setTotalFilesCount(selectedFiles.length);
  //   setUploadedCount(0);
  //   // ✅ Pass the current files array
  //   uploadSingleFile(0, selectedFiles);
  // };
  const handleUpload = async () => {
  if (selectedFiles.length === 0) {
    alert("No files selected for upload.");
    return;
  }

  setUploadStatus(true);

  const formData = new FormData();

  selectedFiles.forEach((file) => {
    formData.append("files", file); //  multiple files
  });

  if (value) {
    formData.append("attachmentId", value);
  }

  try {
    const item = await ItemService.uploadFiles(formData);

    const payload = {
      fieldName: name,
      attachmentId: value || item.attachmentId,
      id: value || item.attachmentId,
    };

    onSuccessUpload && onSuccessUpload(payload);

    // reset
    setSelectedFiles([]);
    setFileLinks([]);
    setUploadStatus(false);
    setTotalFilesCount(0);
    setUploadedCount(0);

  } catch (error) {
    console.error("Upload failed:", error);
    alert("Upload failed. Try again.");
    setUploadStatus(false);
  }
};

  const selectFile = () => {
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
    fileInputRef.current.click();
  };

  const getURL = (name) => {
    const file = fileLinks.find((item) => item.name === name);
    return file ? file.url : null;
  };

  return (
    <div>
      <Row>
        <Col xs={12} md={12} lg={12}>
          <label className="block text-sm font-medium leading-6 text-gray-900 infoIconAccordion">
            {label} {required ? (label ? "*" : "") : ""}{" "}
            {extraLabel !== "" ? (
              <i className="bi bi-info-circle" title={extraLabel}></i>
            ) : (
              ""
            )}
          </label>
        </Col>
        <Col xs={6} md={6} lg={6}>
          {disabled ? (
            <div className="fileChooseDisabled">
              <i className="bi bi-upload mr-2"></i>
              Choose File
            </div>
          ) : (
            <div 
              onClick={selectFile} 
              className="fileChoose"
              style={{ cursor: uploadStatus ? "not-allowed" : "pointer", opacity: uploadStatus ? 0.6 : 1 }}
            >
              <i className="bi bi-upload mr-2"></i>
              Choose File
            </div>
          )}
        </Col>
        <Col xs={6} md={6} lg={6} className="commLeftRightPadding">
          {disabled ? (
            <button className="btnTable" style={{ width: "100%" }} disabled>
              <i className="bi bi-upload"></i> Upload Files
            </button>
          ) : (
            <>
              <LoaderSmall isLoading={uploadStatus} />
              {!uploadStatus && (
                <button
                  onClick={handleUpload}
                  className="btnTable"
                  style={{ width: "100%" }}
                  disabled={uploadStatus || selectedFiles.length === 0}
                >
                  <i className="bi bi-upload"></i> Upload Files
                </button>
              )}
              {uploadStatus && (
                <button
                  className="btnTable"
                  style={{ width: "100%" }}
                  disabled
                >
                  <i className="bi bi-upload"></i> Uploading ({uploadedCount}/{totalFilesCount})
                </button>
              )}
            </>
          )}
        </Col>
      </Row>

      <input
        className="inputBox"
        type="file"
        ref={fileInputRef}
        accept={allowedTypes.join(",")}
        multiple={multiple}
        onChange={handleFileChange}
        disabled={uploadStatus}
        style={{ marginBottom: "10px", display: "none" }}
      />

      {selectedFiles.length > 0 && (
        <ul>
          {selectedFiles.map((file, index) => (
            <li 
              key={index} 
              className="fileUploadedList"
              style={{
                opacity: uploadingIndex === index ? 0.6 : 1,
                backgroundColor: uploadingIndex === index ? "#f0f0f0" : "transparent"
              }}
            >
              <i className="bi bi-paperclip"></i>{" "}
              <span style={{ flex: 1 }}>
                {file.name}
                {uploadingIndex === index && <span style={{marginLeft: "10px", color: "#007bff"}}>Uploading...</span>}
              </span>
              <a
                href={getURL(file.name)}
                target="_blank"
                rel="noopener noreferrer"
                style={{ flex: 1 }}
              >
                <i className="bi bi-eye"></i>
              </a>
              <i
                className="bi bi-x-circle fileRemoveIcon"
                onClick={() => handleRemoveFile(index)}
                style={{ 
                  cursor: uploadStatus ? "not-allowed" : "pointer",
                  opacity: uploadStatus ? 0.5 : 1
                }}
              ></i>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default FileUploadComponentForHB;
